import { Observable, map } from "rxjs";
import { url } from "./APIEndPoints";
import HttpService from "./HttpService"; 
import {
  buildParamString,
  IAPIResponse,
} from "@mindmemobile/mm-shared-global";
import { IAPIMediaGridModel, IAPIUploadMediaRequestModel, IAPIUploadMediaResponseModel } from "../interfaces/IAPIMediaModels";

class MediaService {
  private httpService: HttpService;

  constructor() {
    this.httpService = new HttpService(
      undefined,
      `${process.env.REACT_APP_API_KEY}`,
      process.env.REACT_APP_API_BASE_URL
    );
  }

  uploadMedia(
    data: IAPIUploadMediaRequestModel
  ): Observable<IAPIUploadMediaResponseModel> {
    const formData = new FormData();
    if (!data.Files) {
      return new Observable<IAPIUploadMediaResponseModel>();
    }
    for (let i = 0; i < data.Files.length; i++) {
      const fileToUpload = data.Files[i] as File;
      formData.append("Files", fileToUpload);
    }
    formData.append("AccountId", data.AccountId);
    const response = this.httpService
      .uploadFile<IAPIResponse<IAPIUploadMediaResponseModel>>(
        url.uploadMedia,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .pipe(map((result) => result.result));
    return response;
  }

  getMedias(
    accountId: string,
    pageNumber: number,
    pageSize: number,
    filter: string,
    searchValue = ""
  ): Observable<IAPIResponse<IAPIMediaGridModel[]>> {
    const params: string = buildParamString({
      accountId: accountId,
      pageNumber: pageNumber,
      pageSize: pageSize,
      filter: filter,
      searchValue: searchValue,
    });
    return this.httpService.get<IAPIResponse<IAPIMediaGridModel[]>>(
      url.getMedias,
      params
    );
  }
}
export default new MediaService();
